import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "gis-tabview-container p-d-flex p-flex-column kn-flex" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "p-field p-col-12 p-my-1" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  for: "label",
  class: "p-error"
}
const _hoisted_9 = { class: "p-field p-col-12" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "desc",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-d-flex p-flex-row p-jc-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnOverlaySpinnerPanel = _resolveComponent("KnOverlaySpinnerPanel")
  const _component_DatasetLayerTab = _resolveComponent("DatasetLayerTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_Badge = _resolveComponent("Badge")
  const _component_DatasetJoinTab = _resolveComponent("DatasetJoinTab")
  const _component_IndicatorsTab = _resolveComponent("IndicatorsTab")
  const _component_MenuTab = _resolveComponent("MenuTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-rounded p-button-plain",
          label: _ctx.$t('workspace.gis.editMap'),
          disabled: !_ctx.canOpenMap,
          onClick: _ctx.openMapConfirm
        }, null, 8, ["label", "disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.saveDialogDisabled,
          onClick: _ctx.saveOrUpdateGis
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeGis
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_KnOverlaySpinnerPanel, { visibility: _ctx.loading }, null, 8, ["visibility"]),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_TabView, {
            key: 0,
            class: "p-d-flex p-flex-column kn-flex"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  (_ctx.$route.path.includes('new'))
                    ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('workspace.gis.datasetLayerTitle')), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('managers.layersManagement.layerTitle')), 1))
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DatasetLayerTab, {
                    documentDataProp: _ctx.documentData,
                    isDatasetChosen: _ctx.isDatasetChosen,
                    onDatasetChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDatasetChange($event))),
                    onLayerChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onLayerChange($event))),
                    onDriverChanged: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDriverChange($event))),
                    onDatasetDeleted: _ctx.onDatasetDelete
                  }, null, 8, ["documentDataProp", "isDatasetChosen", "onDatasetDeleted"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, {
                disabled: !_ctx.documentData.selectedDataset.length > 0 || !_ctx.documentData.selectedLayer.length > 0
              }, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('workspace.gis.datasetJoinTitle')), 1),
                  (_ctx.validations.joinsInvalid)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        value: "",
                        class: "p-ml-2",
                        severity: "danger"
                      }))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_DatasetJoinTab, {
                    documentDataProp: _ctx.documentData,
                    onJoinsValidationChanged: _ctx.validationChanged
                  }, null, 8, ["documentDataProp", "onJoinsValidationChanged"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_TabPanel, {
                disabled: !_ctx.documentData.selectedDataset.length > 0
              }, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('workspace.gis.indicators')), 1),
                  (_ctx.validations.indicatorsInvalid)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        value: "",
                        class: "p-ml-2",
                        severity: "danger"
                      }))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_IndicatorsTab, {
                    documentDataProp: _ctx.documentData,
                    onIndicatorsValidationChanged: _ctx.validationChanged
                  }, null, 8, ["documentDataProp", "onIndicatorsValidationChanged"])
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_TabPanel, null, {
                header: _withCtx(() => [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('workspace.gis.filtersMenu')), 1),
                  (_ctx.validations.filtersInvalid)
                    ? (_openBlock(), _createBlock(_component_Badge, {
                        key: 0,
                        value: "",
                        class: "p-ml-2",
                        severity: "danger"
                      }))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_MenuTab, {
                    documentDataProp: _ctx.documentData,
                    onFiltersValidationChanged: _ctx.validationChanged
                  }, null, 8, ["documentDataProp", "onFiltersValidationChanged"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.saveDialogVisible)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          class: "p-fluid kn-dialog--toolbar--primary",
          style: _ctx.descriptor.style.dialogSize,
          visible: _ctx.saveDialogVisible,
          modal: true,
          closable: false
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workspace.gis.save')), 1)
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                class: "kn-button kn-button--secondary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveDialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                disabled: _ctx.saveButtonDisabled,
                onClick: _ctx.buildGisTemplate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_InputText, {
                  id: "label",
                  class: ["kn-material-input", { 'p-invalid': _ctx.documentData.documentLabel == null || _ctx.documentData.documentLabel == '' }],
                  modelValue: _ctx.documentData.documentLabel,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.documentData.documentLabel = $event))
                }, null, 8, ["modelValue", "class"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
              ]),
              (_ctx.documentData.documentLabel == null || _ctx.documentData.documentLabel == '')
                ? (_openBlock(), _createBlock("small", _hoisted_8, "Field required *"))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _createVNode(_component_InputText, {
                  id: "desc",
                  class: "kn-material-input kn-width-full",
                  modelValue: _ctx.documentData.documentDesc,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.documentData.documentDesc = $event))
                }, null, 8, ["modelValue"]),
                _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.description')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["style", "visible"]))
      : _createCommentVNode("", true)
  ]))
}